import { render, staticRenderFns } from "./SendTelegramMessageTemplate.vue?vue&type=template&id=bbad3192&"
import script from "./SendTelegramMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./SendTelegramMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendTelegramMessageTemplate.vue?vue&type=style&index=0&id=bbad3192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports